import { render, staticRenderFns } from "./FeaturesListItem.vue?vue&type=template&id=4e0dc334&scoped=true&"
import script from "./FeaturesListItem.vue?vue&type=script&lang=js&"
export * from "./FeaturesListItem.vue?vue&type=script&lang=js&"
import style0 from "./FeaturesListItem.vue?vue&type=style&index=0&id=4e0dc334&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e0dc334",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VFlex,VLayout,VSpacer})
